// 记录实名来源产品线索
import {getParams} from '@/utils/util';
import {API_IS_ACTIVATED_NEW} from './isActivated';

export function getProductHeader() {
    const hashSeg = location.hash ? location.hash.split('?') : [];
    const search = hashSeg.length > 1 ? hashSeg[1] : '';
    const query: any = getParams(search);
    const productHeader = query?.product ? query?.product : null;
    return productHeader ? {
        'X-Bce-Qualify-Product': productHeader,
    } : null;
}

export function getNeedProductHeader(url: string) {
    const needProduct = API_IS_ACTIVATED_NEW[url];
    if (needProduct) {
        const ProductHeader = getProductHeader();
        return ProductHeader;
    }
    return null;
}
